import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectedPosition, Overlay, OverlayModule, ScrollStrategy } from '@angular/cdk/overlay';

import { E2EModule } from 'cypress/support/e2e.module';
import { DropdownOption } from 'src/app/shared/mine-dropdown/mine-dropdown.interface';
import { ContentPipeModule } from 'src/app/services/content/content-pipe.module';
import { MenuPositionEnum } from 'src/app/shared/mine-action-menu/mine-action-menu-enum';
import { Animations } from 'src/app/animations/animations';
import { TippyModule } from 'src/app/shared/tippy.module';

@Component({
    standalone: true,
    selector: 'notification-action-menu',
    templateUrl: './notification-action-menu.component.html',
    styleUrls: ['./notification-action-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ContentPipeModule, CommonModule, TippyModule, E2EModule, OverlayModule],
    animations: [Animations.fadeInOut],
})
export class NotificationActionMenuComponent implements AfterViewInit {

    @Output() action = new EventEmitter<string>();

    @Input() options: DropdownOption[];

    @Input() position = MenuPositionEnum.Bottom;

    @Input() panelStyle: { [key: string]: string } = {};

    @Output() menuOpened = new EventEmitter<void>();

    @Output() menuClosed = new EventEmitter<void>();

    @ViewChild('contentWrapper', { static: false })
    contentWrapper: ElementRef<HTMLElement>;

    showActionsMenu: boolean;

    hasNgContent = false;

    readonly scrollStrategy: ScrollStrategy;

    constructor(
        private cdr: ChangeDetectorRef,
        private overlay: Overlay,
    ) {
        this.scrollStrategy = this.overlay.scrollStrategies.close();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.contentWrapper?.nativeElement) {
                const hasContent = this.contentWrapper.nativeElement.children.length > 0 ||
                    (this.contentWrapper.nativeElement.textContent?.trim().length ?? 0) > 0;
                this.hasNgContent = hasContent;
                this.cdr.detectChanges();
            }
        }, 0);
    }

    menuClick($event: MouseEvent): void {
        this.showActionsMenu = !this.showActionsMenu;
        if (this.showActionsMenu) {
            this.menuOpened.emit();
        } else {
            this.menuClosed.emit();
        }
        this.stopEvent($event);
    }

    onActionClick(optionId: string, $event: MouseEvent): void {
        if (this.options.find(option => option.id === optionId)?.disabled) {
            return;
        }
        this.action.emit(optionId);
        this.showActionsMenu = false;
        this.menuClosed.emit();
        this.stopEvent($event);
    }

    closeMenu(): void {
        if (!this.showActionsMenu) {
            return;
        }
        this.showActionsMenu = false;
        this.menuClosed.emit();
        this.cdr.markForCheck();
    }

    get overlayPositions(): ConnectedPosition[] {
        switch (this.position) {
            case MenuPositionEnum.Top:
                return [{
                    originX: 'end',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'bottom',
                    offsetY: -5,
                }];
            case MenuPositionEnum.Bottom:
            case MenuPositionEnum.BottomRight:
            default:
                return [{
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top',
                    offsetY: 5,
                }];
        }
    }

    private stopEvent($event: MouseEvent): void {
        $event.stopPropagation();
        $event.preventDefault();
    }
}
